export class GptAPI {
  static get baseUrl() {
    return process.env.NODE_ENV === "development"
      ? process.env.REACT_APP_API_BASE_URL
      : process.env.REACT_APP_API_BASE_URL;
  }
  static askGptByText(text: string, file_path?: string, limit?: number) {
    const params = new URLSearchParams();
    params.append("text", text);

    return {
      method: "POST",
      url: this.baseUrl + "/api/openai/gpt?" + params.toString(),
    };
  }
}
